import { Bot } from 'lucide-react';

interface EmptyStateProps {
  searchQuery?: string;
  onClearFilters: () => void;
}

export function EmptyState({ searchQuery, onClearFilters }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-20 px-6">
      <div className="w-20 h-20 rounded-full bg-[#1a1a1a] flex items-center justify-center mb-6">
        <Bot className="w-10 h-10 text-[#9595a5]" />
      </div>
      <h3 className="font-['Poppins',sans-serif] text-2xl font-semibold text-white mb-3">
        No characters found
      </h3>
      <p className="text-[#9595a5] text-center mb-6 max-w-md">
        {searchQuery
          ? `No results for "${searchQuery}". Try different keywords or adjust your filters.`
          : 'Adjust your filters to discover more AI characters.'}
      </p>
      <button
        onClick={onClearFilters}
        className="mt-6 px-6 py-2.5 rounded-lg bg-white text-black font-medium hover:opacity-90 transition-all"
      >
        Clear All Filters
      </button>
    </div>
  );
}
